@import "~/styles/variables";

// This will make the font transition easier, and can be removed when the body font changes
.Text {
  @include font-family("sans");

  &.serif {
    @include font-family("serif");
  }

  &.upper {
    text-transform: uppercase;
  }

  @each $size, $val in $space-sizes {
    &.stack_#{$size} {
      @include stack($size);
    }
  }
}

@each $name, $val in $font-colors {
  .#{$name} {
    @include font-color($name);
  }
}

@each $name, $val in $font-sizes {
  .#{$name} {
    @include font-size($name);
  }
}

@each $name, $val in $font-weights {
  .#{$name} {
    @include font-weight($name);
  }
}
